import { Component, ViewEncapsulation } from "@angular/core";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";

@Component({
  selector: "uni-unwind-and-reconciliation-doc",
  standalone: false,
  templateUrl: "./unwind-and-reconciliation-doc.component.html",
  encapsulation: ViewEncapsulation.None,
  host: { class: "flex flex-col flex-1 overflow-hidden" },
})
export class UnwindAndReconciliationDocComponent extends DomainBaseComponent {
  mdSrc = "/assets/docs/unwind-and-reconciliation.md";

  constructor(domainService: DomainService) {
    super(domainService);
    this.isPageReady = true;
  }
}
